import {Component, Input} from '@angular/core';
import {DialogRef} from '@angular/cdk/dialog';

@Component({
    template: '',
    standalone: false
})
export abstract class PopupDialogBase  {
  @Input() dialogRef: DialogRef<any>;

  public close(result?: any) {
    this.dialogRef.close(result);
  }
}
